import algosdk from "algosdk";

import {getAlgosdkCredentialsForNetwork} from "./algodHelpers";
import {
  AlgorandNodeProviderType,
  DEFAULT_ALGORAND_NODE_PROVIDER_TYPE,
  ALGORAND_MIN_TX_FEE
} from "./algodConstants";

class AlgodManager {
  client: algosdk.Algodv2;
  indexer: algosdk.Indexer;
  providerType: AlgorandNodeProviderType;
  suggestedTransactionFee = ALGORAND_MIN_TX_FEE;

  constructor({
    providerType,
    shouldCheckTransactionFee = true
  }: {
    providerType: AlgorandNodeProviderType;
    shouldCheckTransactionFee?: boolean;
  }) {
    const algosdkCredentials = getAlgosdkCredentialsForNetwork(providerType);

    this.providerType = providerType;
    this.client = new algosdk.Algodv2(
      algosdkCredentials.tokens.client,
      algosdkCredentials.server.client,
      algosdkCredentials.port
    );
    this.indexer = new algosdk.Indexer(
      algosdkCredentials.tokens.indexer,
      algosdkCredentials.server.indexer,
      algosdkCredentials.port
    );

    if (shouldCheckTransactionFee) {
      this.setSuggestedTransactionFee();
    }
  }

  updateClient(providerType: AlgorandNodeProviderType) {
    const algosdkCredentials = getAlgosdkCredentialsForNetwork(providerType);

    this.providerType = providerType;
    this.client = new algosdk.Algodv2(
      algosdkCredentials.tokens.client,
      algosdkCredentials.server.client,
      algosdkCredentials.port
    );
    this.indexer = new algosdk.Indexer(
      algosdkCredentials.tokens.indexer,
      algosdkCredentials.server.indexer,
      algosdkCredentials.port
    );
  }

  private async setSuggestedTransactionFee() {
    const suggestedParams = await this.client.getTransactionParams().do();

    this.suggestedTransactionFee = suggestedParams.minFee || ALGORAND_MIN_TX_FEE;
  }
}

const algod = new AlgodManager({
  providerType: DEFAULT_ALGORAND_NODE_PROVIDER_TYPE
});

export {AlgodManager, algod};
